import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AccountComponent } from "./components/account/account.component";
import { UserProfileComponent } from "./user-profile.component";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { TabsModule } from 'ngx-bootstrap/tabs';
import { RolePermissionComponent } from './components/account/role-management/role-permission/role-permission.component'; // role-managment/role-permission/role-permission.component';
import { CompareRolesSummaryViewComponent } from './components/account/role-management/role-permission/compare-roles-summary-view/compare-roles-summary-view.component';
import { AccountDetailsComponent } from "./components/account/account-details/account-details.component";
import { OrganizationRoleManagementComponent } from "./components/account/organizations-roles/organization-role-management/organization-role-management.component";
import { MySummaryViewComponent } from "./components/account/role-management/role-permission/my-summary-view/my-summary-view.component";
import { CompareRolesDetailsComponent } from "./components/account/role-management/role-permission/compare-roles-details/compare-roles-details.component";
import { RoleRequestContainerComponent } from "./components/account/role-request/role-request-container/role-request-container.component";

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [RouterModule,
    FormsModule,
    CommonModule,
    NgxSpinnerModule,
    TabsModule,
    RoleRequestContainerComponent, UserProfileComponent,
    AccountComponent,
    OrganizationRoleManagementComponent,
    MySummaryViewComponent,
    AccountDetailsComponent,
    RolePermissionComponent,
    CompareRolesSummaryViewComponent,
    CompareRolesDetailsComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class UserProfileModule { }
